package utils

import kotlin.js.Date

fun Long.timestampToDefaultValueString() =
    Date(this - Date().getTimezoneOffset() * 60_000).toISOString().substring(0, 16)
